export const searchCategory = (ID, category) => {
    if (category && category.id === ID) return category;
    if (category && category.children && category.children.length > 0) {
      for (const child of category.children) {
        const result = searchCategory(ID, child);
        if (result) return result;
      }
    }
    return null;
  };

  export const findCategoryOption = (category, id) => {
    if (category.id === id) {
        return category; 
    }
    
    if (category.children && category.children.length > 0) {
        for (const child of category.children) {
            const result = findCategoryOption(child, id);
            if (result) {
                return result; 
            }
        }
    }
    return null; 
};

  export const findAllCategoryIds = (category, ids=[]) => {
    ids.push({name: category.name, id: category.id});
    if (category.children && category.children.length > 0) {
      for (const child of category.children) {
        findAllCategoryIds(child, ids);
      }
    }
     return ids
};